import React, { useCallback, useEffect, useMemo, useState } from "react";
import Moment from "react-moment";
import UploadDocPopup from "../UploadDocPopup";
import { useLocation, useNavigate } from "react-router-dom";
import { getFieldData, getFormatedNumber } from "../../Services/appService";
import { useDispatch, useSelector } from "react-redux";
import { getAlert, getConfirmAlert } from "../../Services/appAlerts";
import { getDocDeletedStatus, getUpdateDocSentStatus } from "../../app/store/partner";
import {
  useLoadPartnerFilterCandidateQuery,
  useLoadPartnerCandidateAppsQuery,
  useLoadCandidateAppRuningTasksQuery,
  usePartnerCandidateDocDeleteMutation
} from "../../app/store/partnerApiSlice";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import useDocDownload from "../../app/hooks/useDocDownload";
import { useLoadReqDocumentsQuery, useLoadAppDocumentsQuery } from "../../app/store/candidateApiSlice";
import { OverlayTrigger, Popover } from "react-bootstrap";

const CANDIDATE_WORKING_HUB_STYLES = {
  pageActions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    margin: "4px 0 12px 0"
  },
  backButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "6px 14px",
    fontSize: "12.5px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  tableWrap: {
    border: "1px solid rgba(226, 232, 240, 0.95)",
    borderRadius: "18px",
    overflow: "hidden",
    backgroundColor: "#ffffff",
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)",
    marginBottom: "20px"
  },
  summaryTable: {
    width: "100%",
    marginBottom: 0,
    borderCollapse: "separate",
    borderSpacing: 0,
    fontSize: "13px",
    color: "#334155"
  },
  table: {
    width: "100%",
    marginBottom: 0,
    borderCollapse: "separate",
    borderSpacing: 0,
    fontSize: "13px",
    color: "#334155"
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    padding: "14px 16px",
    whiteSpace: "nowrap",
    verticalAlign: "top"
  },
  tableCell: {
    padding: "14px 16px",
    borderBottom: "1px solid rgba(241, 245, 249, 1)",
    verticalAlign: "top",
    fontWeight: 600
  },
  idPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "4px 10px",
    borderRadius: "999px",
    backgroundColor: "#eff6ff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    color: "#2563eb",
    fontSize: "12px",
    fontWeight: 600,
    marginBottom: "6px"
  },
  secondaryPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "4px 10px",
    borderRadius: "999px",
    backgroundColor: "#f1f5f9",
    color: "#475569",
    fontSize: "12px",
    fontWeight: 600
  },
  candidateAvatar: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#2563eb",
    fontSize: "13px",
    fontWeight: 600,
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.08)",
    flexShrink: 0
  },
  candidateName: {
    margin: 0,
    color: "#0f172a",
    fontSize: "14px",
    fontWeight: 600,
    textTransform: "uppercase"
  },
  infoText: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    color: "#475569",
    fontSize: "12.5px",
    lineHeight: 1.45
  },
  statusPillBase: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    borderRadius: "999px",
    padding: "4px 10px",
    fontSize: "12px",
    fontWeight: 600
  },
  successPill: {
    color: "#166534",
    backgroundColor: "#dcfce7"
  },
  warningPill: {
    color: "#92400e",
    backgroundColor: "#fef3c7"
  },
  neutralPill: {
    color: "#475569",
    backgroundColor: "#f1f5f9"
  },
  card: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 0.95)",
    backgroundColor: "#ffffff",
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)",
    overflow: "hidden"
  },
  cardHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)"
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    flexWrap: "wrap"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minWidth: 0
  },
  titleIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#ffffff",
    color: "#2563eb",
    fontSize: "14px",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 4px 12px rgba(37, 99, 235, 0.06)",
    flexShrink: 0
  },
  title: {
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: 1.25,
    color: "#0f172a",
    margin: 0
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  cardBody: {
    padding: "0"
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "14px",
    padding: "20px 22px"
  },
  statCard: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    backgroundColor: "#ffffff",
    border: "1px solid rgba(226, 232, 240, 0.95)",
    borderRadius: "16px",
    padding: "16px",
    boxShadow: "0 6px 18px rgba(15, 23, 42, 0.03)",
    transition: "all 0.2s ease"
  },
  statIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eff6ff",
    color: "#2563eb",
    fontSize: "14px",
    flexShrink: 0
  },
  statContent: {
    minWidth: 0
  },
  statLabel: {
    margin: "0 0 4px 0",
    color: "#64748b",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase"
  },
  statValue: {
    margin: 0,
    color: "#0f172a",
    fontSize: "24px",
    fontWeight: 800,
    lineHeight: 1
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "6px 14px",
    fontSize: "12.5px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  textButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#2563eb",
    padding: "6px 14px",
    fontSize: "12.5px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  dangerButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    borderRadius: "8px",
    border: "1px solid #fca5a5",
    background: "#ffffff",
    color: "#dc2626",
    padding: "6px 14px",
    fontSize: "12.5px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    marginLeft: "8px"
  },
  emptyState: {
    padding: "42px 24px",
    textAlign: "center",
    backgroundColor: "#ffffff",
    color: "#64748b",
    fontSize: "14px"
  }
};

const getInitials = (firstName, lastName) => {
  const f = firstName ? firstName.trim()[0] : "";
  const l = lastName ? lastName.trim()[0] : "";
  return (f + l).toUpperCase() || "??";
};

const ROUTE_CONFIG = [
  { name: "Contract Management", url: "" },
  { name: "List of Candidates", url: "/PartnerCandidates" },
];

export default function CandidateWorkingHub() {
  const [selectedItem, setSelectedItem] = useState(null);
  const [docShowHide, setDocShowHide] = useState(false);
  const [docType, setDocType] = useState("");

  const docSendStatus = useSelector(getUpdateDocSentStatus);
  const docDeletedStatusSelector = useSelector(getDocDeletedStatus);

  const [handleDownloadFile] = useDocDownload();

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Candidate Upload Documents"));
    dispatch(setCurrentRoute(ROUTE_CONFIG));
  }, [dispatch]);

  useEffect(() => {
    const state = location.state;
    if (state) {
      setSelectedItem(state);
    }
  }, [location.state]);

  const subcontractorFuid = selectedItem?.subcontractor?.fuid;
  const performerId = selectedItem?.performerid;

  // RTK Query: Declarative Loading of Filter Candidate
  const { data: filterCandidateReport, refetch: refetchFilterCandidate } = useLoadPartnerFilterCandidateQuery(
    { partId: subcontractorFuid, perfId: performerId },
    { skip: !subcontractorFuid || !performerId }
  );

  const candidateObj = useMemo(() => {
    if (filterCandidateReport && filterCandidateReport.length > 0) {
      return filterCandidateReport[0];
    }
    return null;
  }, [filterCandidateReport]);

  // RTK Query: Declarative Loading of Partner Candidate Apps
  const { data: partnerCandidateApps } = useLoadPartnerCandidateAppsQuery(
    performerId,
    { skip: !performerId }
  );

  const appWorkflow = useMemo(() => {
    if (partnerCandidateApps && partnerCandidateApps.length > 0) {
      const mainWorkflow = partnerCandidateApps.filter(x => x.workflowType === 1);
      return mainWorkflow.length > 0 ? mainWorkflow[0] : null;
    }
    return null;
  }, [partnerCandidateApps]);

  // RTK Query: Declarative Loading of Running Tasks
  const { data: partCandidateAppTasks = [] } = useLoadCandidateAppRuningTasksQuery(
    { wfId: appWorkflow?.oldWorkflowId, userId: performerId },
    { skip: !appWorkflow || !performerId }
  );

  const wfTask = useMemo(() => {
    if (partCandidateAppTasks && partCandidateAppTasks.length > 0) {
      const filterTasks = partCandidateAppTasks.filter(x => x.taskType === 1 && x.wiid > 0);
      return filterTasks.length > 0 ? filterTasks : null;
    }
    return null;
  }, [partCandidateAppTasks]);

  // RTK Query: Declarative Loading of Required Documents
  const { data: reqDocumentsReport = [], refetch: refetchReqDocuments } = useLoadReqDocumentsQuery(
    wfTask?.[0]?.ciid,
    { skip: !wfTask?.[0]?.ciid }
  );

  const reqDocuments = useMemo(() => {
    if (!reqDocumentsReport) return [];
    return reqDocumentsReport.filter(
      (x) => x.sendStatus === true && x.performerId !== performerId
    );
  }, [reqDocumentsReport, performerId]);

  // RTK Query: Declarative Loading of App Documents
  const { data: appDocuments = [] } = useLoadAppDocumentsQuery(
    { wfId: appWorkflow?.oldWorkflowId, userId: performerId },
    { skip: !appWorkflow || !performerId }
  );

  const allAppDocs = appDocuments;

  const [partnerCandidateDocDeleteMutation] = usePartnerCandidateDocDeleteMutation();

  useEffect(() => {
    if (docSendStatus === "success") {
      getAlert("", "Sent Successfully", "success");
      refetchFilterCandidate();
    }
  }, [docSendStatus, refetchFilterCandidate]);

  const handleUploadDocShowHide = useCallback((docs) => {
    if (docs === "save") {
      setDocShowHide(false);
      setDocType("");
      refetchReqDocuments();
    } else {
      setDocShowHide(true);
      setDocType(docs);
    }
  }, [refetchReqDocuments]);

  const getPopover = useCallback((notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <i className="fa fa-info-circle btn btn-sm" style={{ cursor: "pointer" }}></i>
      </OverlayTrigger>
    );
  }, []);

  const getPopover1 = useCallback((notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <button className="btn btn-sm" style={CANDIDATE_WORKING_HUB_STYLES.textButton}>
          <i className="fa fa-info-circle" aria-hidden="true"></i> View
        </button>
      </OverlayTrigger>
    );
  }, []);

  const handleDeleteFile = useCallback(async (doc, type, item) => {
    if (item.status === 1) return getAlert("", "You cannot delete approved document", "error");
    const confirm = await getConfirmAlert("", "Are you sure you want to delete this document?", "warning");
    if (confirm.isConfirmed) {
      try {
        await partnerCandidateDocDeleteMutation({ id: doc.id, type }).unwrap();
      } catch (err) {
        console.error("Error deleting document", err);
      }
    }
  }, [partnerCandidateDocDeleteMutation]);

  useEffect(() => {
    if (docDeletedStatusSelector) {
      getAlert("", "Deleted Successfully", "success");
      refetchReqDocuments();
    }
  }, [docDeletedStatusSelector, refetchReqDocuments]);

  const getReqRefDocs = useCallback((item) => {
    if (item.refDocId > 0) {
      const findDocs = allAppDocs.filter(x => x.uploadId === item.refDocId);
      if (findDocs.length > 0) {
        return (
          <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
            {findDocs.map(doc =>
              <button
                className="btn btn-sm"
                key={doc.id || doc.documentName}
                style={{ ...CANDIDATE_WORKING_HUB_STYLES.textButton, marginRight: "8px", marginBottom: "8px" }}
                title="Download Document"
                onClick={() => handleDownloadFile(doc)}
              >
                <i className="fa fa-paperclip" aria-hidden="true"></i>
                {doc.documentName}
              </button>
            )}
            <span style={CANDIDATE_WORKING_HUB_STYLES.infoText}>{item.documnetName}</span>
          </td>
        );
      }
    }

    return <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>{item.documnetName}</td>;
  }, [allAppDocs, handleDownloadFile]);

  const getReqUploadedDocs = useCallback((item, type) => {
    const achDocs = allAppDocs.filter(
      (x) => x.docType === `req_${item.id}`
    );

    if (achDocs.length === 0) {
      return (
        <React.Fragment>
          <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
            {item.docType?.includes('_c2c_') && (
              <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.statusPillBase, ...CANDIDATE_WORKING_HUB_STYLES.neutralPill }}>
                Contract
              </span>
            )}
            {(item.docType !== "sharing" && !item.docType?.includes('_c2c_') && type !== "received") && (
              <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.statusPillBase, ...CANDIDATE_WORKING_HUB_STYLES.warningPill }}>
                <i className="fa fa-clock-o" aria-hidden="true"></i> Pending
              </span>
            )}
            {type === "received" && (
              <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.statusPillBase, ...CANDIDATE_WORKING_HUB_STYLES.successPill }}>
                <i className="fa fa-check" aria-hidden="true"></i> Received
              </span>
            )}
          </td>
          <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
            {item.docType !== "sharing" && !item.docType?.includes('_c2c_') && type !== "received" &&
              <button
                className="btn btn-sm"
                style={CANDIDATE_WORKING_HUB_STYLES.primaryButton}
                onClick={() => handleUploadDocShowHide(`req_${item.id}`)}
              >
                <i className="fa fa-upload" aria-hidden="true"></i> Upload
              </button>
            }
          </td>
        </React.Fragment>
      );
    }

    if (achDocs.length > 0) {
      const doc = achDocs[achDocs.length - 1];
      return (
        <React.Fragment>
          <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
            <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.statusPillBase, ...CANDIDATE_WORKING_HUB_STYLES.successPill }}>
              <i className="fa fa-check" aria-hidden="true"></i> Uploaded
            </span>
          </td>
          <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
            <button
              className="btn btn-sm"
              style={CANDIDATE_WORKING_HUB_STYLES.textButton}
              title="Download Document"
              onClick={() => handleDownloadFile(doc)}
            >
              <i className="fa fa-paperclip" aria-hidden="true"></i>
              {doc.documentName}
            </button>
            {getPopover(doc.notes)}
            <button
              className="btn btn-sm"
              style={CANDIDATE_WORKING_HUB_STYLES.dangerButton}
              title="Delete File"
              onClick={() => handleDeleteFile(doc, "doc", item)}
            >
              <i className="fa fa-trash" aria-hidden="true"></i> Delete
            </button>
          </td>
        </React.Fragment>
      );
    }
  }, [allAppDocs, handleDownloadFile, handleUploadDocShowHide, handleDeleteFile, getPopover]);

  const handleDocumentLoad = useCallback(() => {
    refetchReqDocuments();
  }, [refetchReqDocuments]);

  const item = candidateObj || "";

  const uploadedDocCount = useMemo(() => {
    return reqDocuments.filter((doc) =>
      allAppDocs.some((appDoc) => appDoc.docType === `req_${doc.id}`)
    ).length;
  }, [reqDocuments, allAppDocs]);

  const pendingDocCount = useMemo(() => {
    return Math.max(reqDocuments.length - uploadedDocCount, 0);
  }, [reqDocuments, uploadedDocCount]);

  const sentDocCount = useMemo(() => {
    return candidateObj?.docList?.filter((doc) => doc.sendStatus === true).length || 0;
  }, [candidateObj]);

  return (
    <div className="w-100" style={{ width: "100%" }}>
      <div className="col-md-12" style={CANDIDATE_WORKING_HUB_STYLES.pageActions}>
        <button
          className="btn btn-sm"
          style={CANDIDATE_WORKING_HUB_STYLES.backButton}
          onClick={() => navigate(-1)}
        >
          <i className="fa fa-arrow-left" aria-hidden="true"></i> Back
        </button>
      </div>
      <div className="col-md-12 form-group">
        <div style={CANDIDATE_WORKING_HUB_STYLES.tableWrap}>
          <div className="table-responsive">
            <table className="table align-items-center table-hover mb-0" style={CANDIDATE_WORKING_HUB_STYLES.summaryTable}>
              <thead>
                <tr>
                  <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Candidate #<br />IPCS ID</th>
                  <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Candidate Details</th>
                  <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Agency</th>
                  <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Duration<br />(Start-End)</th>
                  <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Onboarding<br />Status</th>
                </tr>
              </thead>
              <tbody>
                {item !== "" &&
                  <tr>
                    <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
                      <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-start" }}>
                        <span style={CANDIDATE_WORKING_HUB_STYLES.idPill}>
                          <i className="fa fa-user" aria-hidden="true" style={{ fontSize: "10px" }}></i>
                          {item.performerid}
                        </span>
                        <span style={CANDIDATE_WORKING_HUB_STYLES.secondaryPill}>
                          {item.maxloans || "N/A"}
                        </span>
                      </div>
                    </td>
                    <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
                      <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                        <div style={CANDIDATE_WORKING_HUB_STYLES.candidateAvatar}>
                          {getInitials(item.performername, item.lastName)}
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "3px", minWidth: 0 }}>
                          <p style={CANDIDATE_WORKING_HUB_STYLES.candidateName}>
                            {item.performername} {item.lastName}
                          </p>
                          {item.performeremail && (
                            <span style={CANDIDATE_WORKING_HUB_STYLES.infoText}>
                              <i className="fa fa-envelope-o" style={{ fontSize: "11px", color: "#94a3b8" }} aria-hidden="true"></i>
                              {item.performeremail}
                            </span>
                          )}
                          {item.contactNo && (
                            <span style={CANDIDATE_WORKING_HUB_STYLES.infoText}>
                              <i className="fa fa-phone" style={{ fontSize: "11px", color: "#94a3b8" }} aria-hidden="true"></i>
                              {getFormatedNumber(item.contactNo)}
                            </span>
                          )}
                          {getFieldData(item.performerData, "projectengagement", "PositionTitle") && (
                            <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.infoText, color: "#2563eb", fontWeight: 600, marginTop: "2px" }}>
                              <i className="fa fa-briefcase" style={{ fontSize: "11px" }} aria-hidden="true"></i>
                              {getFieldData(item.performerData, "projectengagement", "PositionTitle")}
                            </span>
                          )}
                        </div>
                      </div>
                    </td>
                    <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
                      <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.infoText, fontWeight: 600, color: "#0f172a" }}>
                        <i className="fa fa-building-o" style={{ fontSize: "11px", color: "#94a3b8" }} aria-hidden="true"></i>
                        {getFieldData(item.performerData, "projectengagement", "AgencyName") || "N/A"}
                      </span>
                    </td>
                    <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
                      {item.duration ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                          <span style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "5px",
                            padding: "3px 10px",
                            borderRadius: "6px",
                            backgroundColor: "#eff6ff",
                            border: "1px solid rgba(191, 219, 254, 0.9)",
                            color: "#2563eb",
                            fontSize: "11.5px",
                            fontWeight: 600,
                            width: "fit-content",
                            marginBottom: "4px"
                          }}>
                            <i className="fa fa-clock-o" style={{ fontSize: "10px" }} aria-hidden="true"></i>
                            {item.duration.duration} Months
                          </span>
                          <span style={CANDIDATE_WORKING_HUB_STYLES.infoText}>
                            <i className="fa fa-calendar" style={{ fontSize: "10.5px", color: "#94a3b8" }} aria-hidden="true"></i>
                            Start: <Moment format="MMM Do YYYY">{item.duration.startDate}</Moment>
                          </span>
                          <span style={CANDIDATE_WORKING_HUB_STYLES.infoText}>
                            <i className="fa fa-calendar-check-o" style={{ fontSize: "10.5px", color: "#94a3b8" }} aria-hidden="true"></i>
                            End: <Moment format="MMM Do YYYY">{item.duration.endDate}</Moment>
                          </span>
                        </div>
                      ) : (
                        <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.infoText, color: "#94a3b8" }}>N/A</span>
                      )}
                    </td>
                    <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
                      {item.appSubmit ? (
                        <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.statusPillBase, ...CANDIDATE_WORKING_HUB_STYLES.successPill }}>
                          <i className="fa fa-check-circle" style={{ fontSize: "13px" }} aria-hidden="true"></i> Complete
                        </span>
                      ) : (
                        <span style={{ ...CANDIDATE_WORKING_HUB_STYLES.statusPillBase, ...CANDIDATE_WORKING_HUB_STYLES.warningPill }}>
                          <i className="fa fa-clock-o" style={{ fontSize: "13px" }} aria-hidden="true"></i> Pending
                        </span>
                      )}
                    </td>
                  </tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="col-md-12">
        <div style={CANDIDATE_WORKING_HUB_STYLES.card}>
          <div style={CANDIDATE_WORKING_HUB_STYLES.cardHeader}>
            <div style={CANDIDATE_WORKING_HUB_STYLES.headerRow}>
              <div style={CANDIDATE_WORKING_HUB_STYLES.titleWrap}>
                <div style={CANDIDATE_WORKING_HUB_STYLES.titleIcon}>
                  <i className="fa fa-cloud-upload" aria-hidden="true"></i>
                </div>
                <div>
                  <h1 style={CANDIDATE_WORKING_HUB_STYLES.title}>Candidate Working Hub</h1>
                </div>
              </div>
              <div style={CANDIDATE_WORKING_HUB_STYLES.headerActions}>
                <button
                  className="btn btn-sm"
                  style={CANDIDATE_WORKING_HUB_STYLES.primaryButton}
                  onClick={handleDocumentLoad}
                >
                  <i className="fa fa-refresh" aria-hidden="true"></i> Refresh
                </button>
              </div>
            </div>
          </div>
          <div style={CANDIDATE_WORKING_HUB_STYLES.statsRow}>
            <div style={CANDIDATE_WORKING_HUB_STYLES.statCard}>
              <div style={CANDIDATE_WORKING_HUB_STYLES.statIcon}>
                <i className="fa fa-file-text-o" aria-hidden="true"></i>
              </div>
              <div style={CANDIDATE_WORKING_HUB_STYLES.statContent}>
                <div style={CANDIDATE_WORKING_HUB_STYLES.statLabel}>Required</div>
                <div style={CANDIDATE_WORKING_HUB_STYLES.statValue}>{reqDocuments.length}</div>
              </div>
            </div>
            <div style={CANDIDATE_WORKING_HUB_STYLES.statCard}>
              <div style={CANDIDATE_WORKING_HUB_STYLES.statIcon}>
                <i className="fa fa-check-circle-o" aria-hidden="true"></i>
              </div>
              <div style={CANDIDATE_WORKING_HUB_STYLES.statContent}>
                <div style={CANDIDATE_WORKING_HUB_STYLES.statLabel}>Uploaded</div>
                <div style={CANDIDATE_WORKING_HUB_STYLES.statValue}>{uploadedDocCount}</div>
              </div>
            </div>
            <div style={CANDIDATE_WORKING_HUB_STYLES.statCard}>
              <div style={CANDIDATE_WORKING_HUB_STYLES.statIcon}>
                <i className="fa fa-clock-o" aria-hidden="true"></i>
              </div>
              <div style={CANDIDATE_WORKING_HUB_STYLES.statContent}>
                <div style={CANDIDATE_WORKING_HUB_STYLES.statLabel}>Pending</div>
                <div style={CANDIDATE_WORKING_HUB_STYLES.statValue}>{pendingDocCount}</div>
              </div>
            </div>
            <div style={CANDIDATE_WORKING_HUB_STYLES.statCard}>
              <div style={CANDIDATE_WORKING_HUB_STYLES.statIcon}>
                <i className="fa fa-upload" aria-hidden="true"></i>
              </div>
              <div style={CANDIDATE_WORKING_HUB_STYLES.statContent}>
                <div style={CANDIDATE_WORKING_HUB_STYLES.statLabel}>Sent</div>
                <div style={CANDIDATE_WORKING_HUB_STYLES.statValue}>{sentDocCount}</div>
              </div>
            </div>
          </div>
          <div style={CANDIDATE_WORKING_HUB_STYLES.cardBody}>
            <div className="table-responsive">
              <table className="table align-items-center table-hover mb-0" style={CANDIDATE_WORKING_HUB_STYLES.table}>
                <thead>
                  <tr>
                    <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Date & Time</th>
                    <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Requirement</th>
                    <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Notes</th>
                    <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Status</th>
                    <th style={CANDIDATE_WORKING_HUB_STYLES.tableHeadCell}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {reqDocuments.map((item, key) =>
                    <tr key={item.id || key}>
                      <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>
                        <div style={CANDIDATE_WORKING_HUB_STYLES.infoText}>
                          <i className="fa fa-calendar" style={{ fontSize: "11px", color: "#94a3b8" }} aria-hidden="true"></i>
                          <Moment format="MMM Do YYYY, h:mm a">
                            {item.addedDateTime}
                          </Moment>
                        </div>
                      </td>
                      {getReqRefDocs(item)}
                      <td style={CANDIDATE_WORKING_HUB_STYLES.tableCell}>{getPopover1(item.notes)}</td>
                      {getReqUploadedDocs(item, "req")}
                    </tr>
                  )}
                  {reqDocuments.length === 0 && (
                    <tr>
                      <td colSpan={5} style={{ ...CANDIDATE_WORKING_HUB_STYLES.tableCell, padding: 0 }}>
                        <div style={CANDIDATE_WORKING_HUB_STYLES.emptyState}>
                          No document requirements are available for this candidate yet.
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {docShowHide &&
        <UploadDocPopup
          uploadDocShowHide={docShowHide}
          handleUploadDocModalShowHide={handleUploadDocShowHide}
          runningApplication={wfTask}
          selectedDocType={docType}
          contactDoc={docType === "" ? "Your document has been successfully attached to workbench portal" : "Your required document has been successfully attached to workbench portal"}
        ></UploadDocPopup>}
    </div>
  );
}
